import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarDays, Sun, Moon } from "lucide-react";
import { useSelectedDate } from "@/context/DateContext";
import { useTheme } from "@/context/ThemeContext";
import { dayjs } from "@/lib/time";

export const Topbar = ({ title, subtitle }) => {
    const { date, setDate } = useSelectedDate();
    const { theme, toggle } = useTheme();
    const displayDate = dayjs(date).format("YYYY-MM-DD");

    return (
        <header
            data-testid="app-topbar"
            className="h-12 border-b border-border bg-card/40 backdrop-blur-sm px-3 md:px-4 flex items-center justify-between sticky top-0 z-30"
        >
            <div className="flex items-center gap-3 min-w-0">
                <h1 className="text-sm md:text-base font-semibold truncate" data-testid="topbar-title">
                    {title}
                </h1>
                {subtitle && (
                    <span className="hidden md:inline text-xs text-muted-foreground truncate">
                        {subtitle}
                    </span>
                )}
            </div>
            <div className="flex items-center gap-2">
                <Popover>
                    <PopoverTrigger asChild>
                        <Button
                            data-testid="global-date-picker"
                            variant="outline"
                            size="sm"
                            className="h-8 px-2 gap-2 font-mono text-xs"
                        >
                            <CalendarDays className="h-3.5 w-3.5" />
                            <span>{displayDate}</span>
                            <span className="text-muted-foreground">ET</span>
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent align="end" className="p-0">
                        <Calendar
                            mode="single"
                            selected={new Date(date + "T12:00:00")}
                            onSelect={(d) => d && setDate(dayjs(d).format("YYYY-MM-DD"))}
                            initialFocus
                        />
                    </PopoverContent>
                </Popover>
                <Button
                    data-testid="theme-toggle"
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8"
                    onClick={toggle}
                    aria-label="Toggle theme"
                >
                    {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                </Button>
            </div>
        </header>
    );
};
